import generalIcon from "../../images/icons/general-decorate-icon.svg";
import userIcon from "../../images/icons/user-portrayal-icon.svg";
import usersIcon from '../../images/icons/dark/clients-icon.svg';
import batchCheckIcon from '../../images/icons/batch-check-filled.svg';
import tableStructureIcon from '../../images/icons/table-outline.svg';
import deleteIcon from '../../images/icons/delete-icon.svg';
import managementIcon from '../../images/icons/management-icon.svg';
import paymentIcon from "../../images/icons/payment-icon.svg";

export enum SettingsItemEnum {
  GENERAL = "general",
  PROFILE = "profile",
  VIEW_PROFILE = "view",
  EDIT_PROFILE = "edit",
  TEAM_USERS = "team-users",
  ROLES_PERMISSIONS = "roles-permissions",
  ADD_MEMBER_TEAM = "add-member-team",
  VIEW_MEMBERS_TEAM = "view-members-team",
  SEND_INVITE_TEAM = "send-invite-team",
  STRUCTURE = "structure",
  MANAGEMENT = "management",
  PAYMENT = "payment",
  BASKET = "basket"
}

const settingsItems = [
  {
    id: "profile",
    part: "Мій акаунт",
    items: [
      { id: SettingsItemEnum.GENERAL, title: "Загальні", icon: generalIcon, path: "general" },
      { id: SettingsItemEnum.PROFILE, title: "Профіль", icon: userIcon, path: "profile" },
    ],
  },
  {
    id: "team",
    part: "Команда",
    items: [
      { id: SettingsItemEnum.TEAM_USERS, title: "Користувачі", icon: usersIcon, path: "team" },
      {
        id: SettingsItemEnum.ROLES_PERMISSIONS,
        title: "Ролі та дозволи",
        icon: batchCheckIcon,
      },

    ],
  },
  {
    id: "work-space", part: "Робочий простір", items: [
      { id: SettingsItemEnum.MANAGEMENT, title: "Керування", icon: managementIcon, path: "management" },
      {
        id: SettingsItemEnum.PAYMENT,
        title: "Підписка та оплата",
        icon: paymentIcon,
        path: "payment"
      },]
  },
  {
    id: "settings", part: "Інші налаштування", items: [
      { id: SettingsItemEnum.STRUCTURE, title: "Структура", icon: tableStructureIcon, path: "structure" },
      { id: SettingsItemEnum.BASKET, title: "Кошик", icon: deleteIcon, path: "basket" },
    ]
  },
];

export default settingsItems;

export const currencies = [
  { code: "USD", symbol: "$", name: "Долар" },
  { code: "UAH", symbol: "₴", name: "Гривня" },
  { code: "EUR", symbol: "€", name: "Євро" },
];
